export const samplesEditorIdHeader = '';

export const samplesEditorNrlHeader = 'NRL';

export const samplesEditorDataHeaders = {
    'sample_id':
        'Ihre Probe\u00ADnummer',
    'sample_id_avv':
        'Probe\u00ADnummer nach AVV Data',
    'partial_sample_id':
        'AVV DatA-Teil\u00ADpro\u00ADben-Nr.',
    'pathogen_avv':
        'Erreger (Code oder Text aus AVV DatA-Kat-Nr. 324)',
    'pathogen_text':
        'Erreger (Text)',
    'sequence_id':
        'Ihre Sequenz ID',
    'sequence_status':
        'Sequenz Status',
    'sampling_date':
        'Datum der Probe\u00ADnahme',
    'isolation_date':
        'Datum der Isolierung',
    'sampling_location_avv':
        'Ort der Probe\u00ADnahme (Code aus AVV DatA-Kat-Nr. 313)',
    'sampling_location_zip':
        'Ort der Probe\u00ADnahme (PLZ)',
    'sampling_location_text':
        'Ort der Probe\u00ADnahme (Text)',
    'animal_avv':
        'Tiere (Code aus AVV DatA-Kat-Nr. 339)',
    'matrix_avv':
        'Matrix (Code aus AVV DatA-Kat-Nr. 319)',
    'animal_matrix_text':
        'Tiere / Matrix (Text)',
    'additional_marks_avv':
        'Zusatz\u00ADangaben in der Kenn\u00ADzeichnung (Code aus AVV DatA-Kat-Nr. 337)',
    'control_program_avv':
        'Kontroll\u00ADprogramm (Code aus AVV DatA-Kat-Nr. 322)',
    'sampling_reason_avv':
        'Untersu\u00ADchungs\u00ADgrund (Code aus AVV DatA-Kat-Nr. 326)',
    'program_reason_text':
        'Kontroll\u00ADprogramm / Untersu\u00ADchungs\u00ADgrund (Text)',
    'operations_mode_avv':
        'Betriebsart (Code aus AVV DatA-Kat-Nr. 303)',
    'operations_mode_text':
        'Betriebs\u00ADart (Text)',
    'vvvo':
        'VVVO-Nr / Herde',
    'program_avv':
        'Programm (Code aus AVV DatA-Kat-Nr. 328)',
    'comment':
        'Bemerkung'
};

